"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MGeoService = void 0;
const mgeo_api_1 = require("./mgeo-api");
class MGeoService {
    static async authenticate(path, apiKey) {
        const response = await mgeo_api_1.MGEOAPI.post({
            url: path,
            body: {
                gatewayAcl: apiKey
            }
        });
        if (!response.headers || !response.headers['x-client-id'] || !response.headers['x-client-id-timestamp']) {
            throw new Error('MGeo No headers');
        }
        return {
            xClientId: response.headers['x-client-id'],
            xClientIdTimestamp: response.headers['x-client-id-timestamp']
        };
    }
}
exports.MGeoService = MGeoService;
//# sourceMappingURL=mgeo-service.js.map